import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children, requireRole }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-lin" data-testid="auth-loading">
        <div className="font-serif text-xl text-domaine">Chargement…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/extranet" replace state={{ from: location }} />;
  }
  // New schema: `user.roles` is an array of role codes.
  if (requireRole && !user.roles?.some((r) => requireRole.includes(r))) {
    return <Navigate to="/extranet/tableau-de-bord" replace />;
  }
  return children;
}
